"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Conditional = void 0;
__exportStar(require("./types"), exports);
__exportStar(require("./plugins"), exports);
// Auto-configure Conditional with date support if available
const Conditional_1 = require("./core/Conditional");
const date_plugin_1 = require("./plugins/date-plugin");
// Automatically enable date plugin if dayjs is available
if ((0, date_plugin_1.isDatePluginAvailable)()) {
    Conditional_1.Conditional.registerPlugin(date_plugin_1.DatePlugin);
    Conditional_1.Conditional.configure({ enablePlugins: ['date'] });
}
/**
 * Universal Conditional class with automatic date support
 * Works everywhere and includes date operators if dayjs is available
 */
exports.Conditional = Conditional_1.Conditional;
/**
 * Default export
 */
exports.default = exports.Conditional;
//# sourceMappingURL=index.js.map